import React from 'react'
import { Modal } from 'react-bootstrap'
import './WalletComponent.css'

const AddPointModal = ({ addPointModal, handleCloseAddPointModal, pointSLabData, handleSelectPoint, selectedSlab,setAddPointModal,setSelectedSlab,handlePay }) => {
    return (
        <div>
            <Modal show={addPointModal} onHide={handleCloseAddPointModal} backdrop="static" className='add-point-modal'>
                <Modal.Header closeButton >
                    <h4 className="modal-title common_heading"   >Add Points Plan</h4>

                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {pointSLabData?.map((item, index) => {
                            return (
                                <div className="col-lg-6">
                                    <div className='point-slab-div '>
                                        <h5 className="common_heading mb-0 text-center" >
                                            Package {index + 1}
                                        </h5>
                                        <h6 className=" text-center" >
                                            {item?.Points} Points
                                        </h6>
                                        <h6 className=" text-center" >
                                            {item?.Money} Rs
                                        </h6>
                                        <button type="button" className={selectedSlab?.Id == item?.Id ? "add-point-select-button-active" : "add-point-select-button"} onClick={() => handleSelectPoint(item)}>
                                            Select
                                        </button>

                                    </div>

                                </div>
                            )
                        })}

                    </div>


                </Modal.Body>
                <Modal.Footer className="add-point-footer">
                        <button type="button" className="common_btn btn-secondary add-point-footer-cancel" data-bs-dismiss="modal" onClick={()=>{setAddPointModal(false);setSelectedSlab()}}>Cancel</button>
                        <button type="button" className="common_btn view-data-btn" onClick={handlePay} disabled={!selectedSlab}>Proceed to Pay</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AddPointModal
